import { render, staticRenderFns } from "./encuestas.vue?vue&type=template&id=45f496b6&scoped=true&"
import script from "./encuestas.vue?vue&type=script&lang=js&"
export * from "./encuestas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f496b6",
  null
  
)

export default component.exports